import { Box } from '@mui/material';
import { Trees, Mistle, StarsLeft, StarsRight } from 'src/assets/images';

type Props = React.PropsWithChildren & {};

const InfoBarChristmasImages: React.FC<Props> = ({ children }) => {
  return (
    <Box>
      <Box
        sx={{
          zIndex: 0,
          borderRadius: 4,
          position: 'absolute',
          top: 0,
          left: 0,
          right: 0,
          bottom: 0,
          background: 'linear-gradient(180deg, #00293C, #1C4F6A);',
        }}
      ></Box>
      <img
        style={{
          maxWidth: '100%',
          width: '25%',
          position: 'absolute',
          bottom: '100%',
          right: '5%',
          pointerEvents: 'none',
        }}
        draggable="false"
        src={Trees}
        alt="hohoho"
        loading="lazy"
      />
      <img
        style={{
          maxWidth: '100%',
          width: '50%',
          position: 'absolute',
          bottom: 0,
          left: '50%',
          transform: 'translate(-50%,60%)',
        }}
        src={Mistle}
        alt="hohoho"
        loading="lazy"
        draggable="false"
      />
      <img
        style={{
          maxWidth: '100%',
          position: 'absolute',
          bottom: 4,
          left: 4,
        }}
        src={StarsLeft}
        alt="hohoho"
        loading="lazy"
        draggable="false"
      />

      <img
        style={{
          maxWidth: '100%',
          position: 'absolute',
          top: 4,
          right: 4,
        }}
        src={StarsRight}
        alt="hohoho"
        loading="lazy"
        draggable="false"
      />
    </Box>
  );
};

export default InfoBarChristmasImages;
